import React, { FC } from "react"
import { HR } from "../../atoms/Atoms"
import { Container, H3 } from "@carrotfertility/carotene"
import { Body } from "../../atoms/Bodies"
import { ArrowLink } from "../../atoms/links/ArrowLink"
import { getSupportCenterLink, SupportCenterLinks } from "../../../../utils/SupportCenterLinks"
import L10n from "../../../../lib/carrot-l10n"

const l = new L10n({ locale: "en-US" }).getBoundLocalize()

const ExternalDeductibleInformational: FC = () => {
  return (
    <>
      <Container paddingTopBottom="large">
        <HR color={"black-10"} />
      </Container>

      <H3>{l`Your insurance deductible`}</H3>
      <Container padding="none" stack="small">
        <Body color="black-80">
          {l`You have to meet your insurance deductible before you’re eligible for reimbursements through Carrot.`}
        </Body>
      </Container>

      <ArrowLink
        to={getSupportCenterLink(SupportCenterLinks.HOW_DOES_CARROT_WORK_WITH_MY_INSURANCE)}
      >{l`Learn how your insurance deductible works with Carrot`}</ArrowLink>
    </>
  )
}

export { ExternalDeductibleInformational }
